import { useState, useEffect, useMemo, useCallback } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import 'moment/locale/pt-br';

import { MaterialReactTable } from 'material-react-table';
import { Stack, Button, Box, Tooltip, IconButton, MenuItem, ListItemIcon, useMediaQuery } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

import { podeEditar } from '../../../hooks/usePermisionMRT';
import { useCargoGridModule } from './modules/useCargoGridModule';

import formStyles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import Checkbox from '../../form/Checkbox';
import DataList from '../../form/DataList';
import Input from '../../form/Input';
import InputFloat from '../../form/InputFloat';
import SelectEmpresa from '../../form/SelectEmpresa';
import Select from '../../form/Select';

import * as DataListAPI from '../../../api/dataList';
import * as RHAPI from '../../../api/rh';
import * as TabelaAPI from '../../../api/tabela';


function Form({ token, dados, setDados, empresaId, empresaIds, handleSubmit, btnText, caminhoVoltar, OptionsEmpresa }) {
    const [procedimento, setProcedimento] = useState([]);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const [CBO, setCBO] = useState({});

    //datalist
    const [exame, setExame] = useState({});
    const [optionsExame, setOptionsExame] = useState([]);
    const [optionsCBO, setOptionsCBO] = useState([]);

    //itens das grids
    const [itemAgente, setItemAgente] = useState([]);
    const [itensProcedimento, setItensProcedimento] = useState([]);

    // Estado para rastrear a aba ativa
    const [abaAtiva, setAbaAtiva] = useState(0);
    const [gridAtiva, setGridAtiva] = useState('cabecalho');

    //enums e selects
    const [enumAgente, setEnumAgente] = useState([]);
    //abas
    const [tabEnabled, setTabEnabled] = useState({
        cabecalho: true,
        agente: true,
        procedimento: true,
    });
    /* identifica a aba atual */
    const handleSelect = (index) => {
        setAbaAtiva(index);

        // Definir qual grid será atualizada com base na aba ativa
        switch (index) {
            case 0:
                setGridAtiva('cabecalho');
                break;
            case 1:
                setGridAtiva('agente');
                break;
            case 2:
                setGridAtiva('procedimento');
                break;
            case 3:
                setGridAtiva('assinatura');
                break;
            case 4:
                setGridAtiva('elegiveis');
                break;
            default:
                setGridAtiva('cabecalho');
        }
    };
    const consultaDatalist = async ({ separador, empresaId, tabela, id, descricao, condicao, filtro, ativo, tipo }) => {
        return await DataListAPI.dataList({ empresaId, tabela, id, descricao, condicao, filtro, ativo, tipo });
    };
    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);

        if (table === 'rhCargoAgenteAmbientals') {
            field === 'agente' && setEnumAgente(result ? result : []);
        }
    };

    const consultaCBOById = useCallback(
        async (id) => {
            const result = await TabelaAPI.tabelaById(null, 'rhCBO', id);

            setCBO(result);
            setDados((prev) => ({
                ...prev,
                CBO: result,
                cboId: id,
            }));
        },
        [setCBO, setDados]
    );
    const obterExameTab27 = async (id) => {
        try {
            const result = await RHAPI.obterTab27eSocial({ id });
            return result;
        } catch (error) {
            console.error('Erro ao obter exame da tabela 27:', error);
            return null;
        }
    };
    const [novoAgente, setNovoAgente] = useState({
        uuid: null,

        cargoId: dados.id,
        descricao: null,

        ativo: true,
        funcao: 'Adicionar',
    });
    const [novoProcedimento, setNovoProcedimento] = useState({
        uuid: null,
        cargoId: dados.id,
        tb27eSocialId: null,

        admissional: true,
        demissional: true,
        periodico: true,
        periodicidade: 12,
        mudancaRisco: true,
        retornoTrabalho: true,

        ativo: true,
        funcao: 'Adicionar',
    });
    const [optionsPapeisAssinatura, setOptionsPapeisAssinatura] = useState([]);
    const [papeisAssinaturaSelecionados, setPapeisAssinaturaSelecionados] = useState([]);

    useEffect(() => {
        setCBO(dados.CBO || {});
        consultaEnum('rhCargoAgenteAmbientals', 'agente', null);
        carregarPapeisAssinatura();
    }, []);
    useEffect(() => {
        if (dados?.CBO) {
            setCBO(dados.CBO);
        }

        if (Array.isArray(dados?.assinaturaPapeis)) {
            const papeisIds = dados.assinaturaPapeis.map((item) => item.papelId);
            setPapeisAssinaturaSelecionados(papeisIds);
        }
    }, [dados?.CBO, dados?.assinaturaPapeis]);
    useEffect(() => {
        if (dados.cboId) {
            consultaCBOById(dados.cboId);
        }
    }, [dados.cboId]);

    const carregarPapeisAssinatura = async () => {
        try {
            const result = await RHAPI.listarAssinaturaPapeis();
            setOptionsPapeisAssinatura(result || []);
        } catch (error) {
            console.error('Erro ao carregar papéis de assinatura:', error);
            setOptionsPapeisAssinatura([]);
        }
    };

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name.startsWith('novoAgente.')) {
            const campo = [name.split('.')[1]];
            setNovoAgente((prev) => ({ ...prev, [campo]: type === 'checkbox' ? checked : value }));
        } else if (name.startsWith('novoProcedimento.')) {
            const campo = [name.split('.')[1]];
            setNovoProcedimento((prev) => ({ ...prev, [campo]: type === 'checkbox' ? checked : value }));
        } else if (name.startsWith('CBO.')) {
            setCBO({
                ...CBO,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                tabela: 'rhCBO',
                filtro: value,
            });

            setOptionsCBO(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;
            setDados((prev) => ({
                ...prev,
                cboId: selectedId ?? null,
            }));
        } else if (name.startsWith('Exame.')) {
            setExame({
                ...exame,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                tabela: 'rhTabela27eSocial',
                filtro: value,
            });
            setOptionsExame(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;
            setNovoProcedimento((prev) => ({
                ...prev,
                tb27eSocialId: selectedId ?? null,
            }));
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }

    async function handleOnBlur(e) {}
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit({ ...dados, assinaturaPapelIds: papeisAssinaturaSelecionados });
    };

    const theme = tableThemeCustom();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const agenteGrid = useCargoGridModule({
        tipo: 'agente', cargoId: dados.id, ativa: gridAtiva === 'agente', isMobile,
        listar: RHAPI.listarAgentes, itens: itemAgente, setItens: setItemAgente,
    });
    const procedimentoGrid = useCargoGridModule({
        tipo: 'procedimento', cargoId: dados.id, ativa: gridAtiva === 'procedimento', isMobile,
        listar: RHAPI.listarProcedimentos, itens: itensProcedimento, setItens: setItensProcedimento,
    });
    const fetchData = (tipo) => {
        if (tipo === 'agente') return agenteGrid.atualizar();
        if (tipo === 'procedimento') return procedimentoGrid.atualizar();
    };

    useEffect(() => {
        setDados((prev) => ({ ...prev, rhCargoAgenteAmbientals: itemAgente }));
    }, [itemAgente, setDados]);
    useEffect(() => {
        setDados((prev) => ({ ...prev, rhTabela27eSocials: itensProcedimento }));
    }, [itensProcedimento, setDados]);

    const columnsagente = useMemo(
        () => [
            {
                id: 'agente',
                header: 'Agentes Ambientais inerentes ao cargo',
                columns: [
                    {
                        accessorKey: 'agente',
                        header: 'Agente',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'descricao',
                        header: 'Descrição',
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );
    const columnsprocedimento = useMemo(
        () => [
            {
                id: 'procedimento',
                header: 'Exames e diagnósticos inerentes ao cargo',
                columns: [
                    {
                        accessorKey: 'rhTabela27eSocial.codigo',
                        header: 'Código',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'rhTabela27eSocial.descricao',
                        header: 'Exame',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'admissional',
                        header: 'Admissional',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.admissional;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'demissional',
                        header: 'Demissional',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.demissional;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'periodico',
                        header: 'Períodico',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.periodico;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'periodicidade',
                        header: 'Periodicidade',
                        Cell: ({ row }) => {
                            const value = row.original.periodicidade;
                            return <div style={{ textAlign: 'center' }}>{value > 0 ? `${value} meses` : ''}</div>;
                        },
                    },
                    {
                        accessorKey: 'mudancaRisco',
                        header: 'Mudança Risco',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.mudancaRisco;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'retornoTrabalho',
                        header: 'Retorno Trabalho',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.retornoTrabalho;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.ativo;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );

    const handleNewRegistro = async (obj, tipo) => {
        obj.tipoRotina = tipo;

        if (obj.funcao?.toLowerCase() === 'editar') {
            if (obj.uuid) {
                CreateOrEditRegistro(obj, tipo);
            } else {
                managerRegistro(obj, tipo);
            }
        } else if (obj.funcao.toLowerCase() === 'cancelar') {
            if (obj.uuid) {
                try {
                    const response = await RHAPI.deletarRegistro(obj);
                    setFlashMessage(response.message, response.type);
                    limparRegistro(tipo);
                } catch (error) {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                }
            } else {
                if (tipo === 'agente') {
                    setItemAgente((prevItens) => {
                        const novosItens = [...prevItens];
                        novosItens.splice(obj.index, 1);
                        return novosItens;
                    });
                } else if (tipo === 'procedimento') {
                    setItensProcedimento((prevItens) => {
                        const novosItens = [...prevItens];
                        novosItens.splice(obj.index, 1);
                        return novosItens;
                    });
                }
            }
        } else {
            //cadastrar
            if (dados.id) {
                //incluir o numero do movimento ao objeto
                obj.cargoId = dados.id;

                //verificar duplicidade
                const result = await RHAPI.duplicidadeRegistro(obj);

                if (result && obj.funcao?.toLowerCase() === 'adicionar') {
                    setFlashMessage('Registo em duplicidade!', 'warning');
                    handleItemRegistro(result, null, 'Adicionar', tipo);
                    return;
                }

                CreateOrEditRegistro(obj, tipo);
            } else {
                managerRegistro(obj, tipo);
            }
        }

        limparRegistro(tipo);
    };

    const managerRegistro = async (obj, tipo) => {
        if (tipo === 'agente') {
            atualizarAgente(obj);
        } else if (tipo === 'procedimento') {
            await atualizarProcedimento(obj);
        }

        limparRegistro(tipo);
    };

    //funções auxiliares para simplificar o código
    const atualizarAgente = (obj) => {
        const isAtualizacao = typeof obj.index === 'number';

        const novoItem = {
            uuid: obj.uuid,
            cargoId: obj.cargoId || dados.Id,
            agente: obj.agente,
            descricao: obj.descricao,
            ativo: obj.ativo,
        };

        setItemAgente((prev) => {
            const atualizados = [...prev];
            if (isAtualizacao) {
                atualizados[obj.index] = { ...prev[obj.index], ...obj };
            } else {
                atualizados.push(novoItem);
            }

            setDados((prevDados) => ({
                ...prevDados,
                rhCargoAgenteAmbientals: atualizados,
            }));

            return atualizados;
        });

    };
    const atualizarProcedimento = async (obj) => {
        const isAtualizacao = typeof obj.index === 'number';
        const tabela27 = await obterExameTab27(obj.tb27eSocialId);

        const novoItem = {
            uuid: obj.uuid,
            cargoId: obj.cargoId || dados.Id,
            tb27eSocialId: obj.tb27eSocialId,
            admissional: obj.admissional,
            demissional: obj.demissional,
            periodico: obj.periodico,
            periodicidade: obj.periodicidade,
            mudancaRisco: obj.mudancaRisco,
            retornoTrabalho: obj.retornoTrabalho,
            ativo: obj.ativo,
            rhTabela27eSocial: tabela27,
        };

        setItensProcedimento((prev) => {
            const atualizados = [...prev];
            if (isAtualizacao) {
                atualizados[obj.index] = { ...prev[obj.index], ...novoItem };
            } else {
                atualizados.push(novoItem);
            }

            setDados((d) => ({
                ...d,
                rhTabela27eSocials: atualizados,
            }));

            return atualizados;
        });

    };

    const handleItemRegistro = async (originalRow, row, funcao, tipo) => {
        // Define os dados para o novo objeto
        const novoItemData =
            tipo === 'agente'
                ? {
                      funcao: funcao,
                      index: row,

                      id: originalRow.id,
                      uuid: originalRow.uuid,
                      ativo: originalRow.ativo,

                      //campos
                      cargoId: originalRow.cargoId,
                      agente: originalRow.agente,
                      descricao: originalRow.descricao,
                  }
                : {
                      funcao: funcao,
                      index: row,

                      id: originalRow.id,
                      uuid: originalRow.uuid,
                      ativo: originalRow.ativo,

                      //campos
                      cargoId: originalRow.cargoId,
                      tb27eSocialId: originalRow.tb27eSocialId,
                      admissional: originalRow.admissional,
                      demissional: originalRow.demissional,
                      periodico: originalRow.periodico,
                      periodicidade: originalRow.periodicidade,
                      mudancaRisco: originalRow.mudancaRisco,
                      retornoTrabalho: originalRow.retornoTrabalho,
                  };

        if (tipo === 'agente') {
            setNovoAgente(novoItemData);
        } else if (tipo === 'procedimento') {
            setNovoProcedimento(novoItemData);
            setExame(originalRow.rhTabela27eSocial);
        }
    };
    const CreateOrEditRegistro = async (obj, tipo) => {
        obj.tipoRotina = tipo; //já é para ter esse campo
        try {
            const result = await RHAPI.managerRegistro(obj);
            setFlashMessage(result.message, result.type);

            //deve atualizar a grid
            dados.id && fetchData(tipo);
            limparRegistro(tipo);
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 422) {
                // Tratar o erro 422, que é específico da validação no servidor
                setFlashMessage('Erro de validação: ' + error.response.data.message, 'error');
            } else {
                // Tratar outros erros de rede ou servidor
                setFlashMessage('Ocorreu um erro ao processar a solicitação.', 'error');
            }
        }
    };
    const limparRegistro = (tipo) => {
        if (tipo === 'agente') {
            setNovoAgente({
                uuid: null,
                cargoId: dados.id,
                descricao: null,

                ativo: true,
                funcao: 'Adicionar',
            });
        } else if (tipo === 'procedimento') {
            setNovoProcedimento({
                uuid: null,
                cargoId: dados.id,
                tb27eSocialId: null,

                admissional: true,
                demissional: true,
                periodico: true,
                periodicidade: 12,
                mudancaRisco: true,
                retornoTrabalho: true,

                ativo: true,
                funcao: 'Adicionar',
            });
            setExame({});
        }
        fetchData(tipo);
    };
    const handleTogglePapelAssinatura = (papelId) => {
        setPapeisAssinaturaSelecionados((prev) => {
            const existe = prev.includes(papelId);
            const next = existe ? prev.filter((id) => id !== papelId) : [...prev, papelId];

            setDados((old) => ({
                ...old,
                assinaturaPapelIds: next,
            }));

            return next;
        });
    };
    return (
        <div>
            <Tabs selectedIndex={abaAtiva} onSelect={handleSelect}>
                <form onSubmit={submit}>
                    <h1>Cargo</h1>
                    <TabList>
                        <Tab title={'Informações do Cargo'}>Cabeçalho</Tab>
                        <Tab title={'Agentes ambientais inerentes ao cargo do colaborador'}>Agentes Ambientais</Tab>
                        <Tab title={'Procedimento e Diagnósticos conforme tabela 27 eSocial'}>Procedimentos</Tab>
                        <Tab title={'Determina os papéis que o cargo detém muito usado no module de assinaturas'}>
                            Papéis de Assinatura
                        </Tab>
                        <Tab title="Define os contextos em que o cargo pode ser utilizado">Cargos Elegíveis</Tab>
                    </TabList>
                    <TabPanel>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                //marginTop: "1rem",
                                flexWrap: 'wrap', // Permite que os itens quebrem a linha quando necessário
                                //justifyContent: "space-between", // Distribui os itens igualmente
                            }}
                        >
                            <SelectEmpresa
                                text="Selecione a Empresa"
                                name="empresaId"
                                options={OptionsEmpresa}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.empresaId || ''}
                                required
                                notOptNull={true}
                            />
                            <Input
                                text="Código"
                                type="text"
                                name="codigo"
                                placeholder="Código"
                                inputWidth="100px"
                                title="Digite o código do cargo"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.codigo || ''}
                                required={true}
                            />
                            <Input
                                text="Descrição"
                                type="text"
                                name="descricao"
                                placeholder="Cargo"
                                inputWidth="250px"
                                title="Digite a descrição do cargo"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.descricao || ''}
                                required={true}
                            />
                            <Input
                                text="Sigla"
                                type="text"
                                name="sigla"
                                placeholder="SIGLA"
                                inputWidth="120px"
                                title="sigla é a simplificação da descrição, aceita apenas 12 caracteres"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.sigla || ''}
                                //required={true}
                                maxLength="12"
                            />
                            <InputFloat
                                text="Fator"
                                type="text"
                                name="fator"
                                placeholder="fator"
                                inputWidth="100px"
                                title="valor do fator multipllicador do indexador, utilizado para calculos no sistema ex. composição do salário, custos de produção, etc. O valor deve ser um número decimal separado por ponto (.)"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.fator}
                                required={true}
                            />
                            <Checkbox
                                title="Ativa quando marcado"
                                text="Ativo"
                                name="ativo"
                                handleOnChange={handleChange}
                                value={dados.ativo}
                                checked={!!dados.ativo}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                //marginTop: "1rem",
                                flexWrap: 'wrap', // Permite que os itens quebrem a linha quando necessário
                                // justifyContent: "space-between", // Distribui os itens igualmente
                            }}
                        >
                            <Input
                                text="CBO"
                                type="text"
                                name="CBO.codigo"
                                placeholder="Código CBO"
                                inputWidth="150px"
                                title="Código Brasileiro de Ocupação - CBO"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={CBO?.codigo}
                                readonly={true}
                            />
                            <DataList
                                text="Descrição do CBO"
                                title={''}
                                name="CBO.descricao"
                                placeholder={'Digite para pesquisar'}
                                inputWidth="510px"
                                filteredOptions={optionsCBO}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={CBO?.descricao}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    //marginTop: "1rem",
                                    flexWrap: 'wrap', // Permite que os itens quebrem a linha quando necessário
                                    // justifyContent: "space-between", // Distribui os itens igualmente
                                }}
                            >
                                <Select
                                    text="Selecione o Agente"
                                    title="Selecio o agente ambiental que afeta a rotina do colaborador"
                                    name="novoAgente.agente"
                                    options={enumAgente}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoAgente.agente || ''}
                                    isEnum={true}
                                    notOptNull={false}
                                />
                                <Input
                                    text="Descrição"
                                    type="text"
                                    name="novoAgente.descricao"
                                    placeholder=""
                                    inputWidth="350px"
                                    title="Digite o código do cargo"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoAgente.descricao || ''}
                                />
                                <Checkbox
                                    title="Ativa quando marcado"
                                    text="Ativo"
                                    name="novoAgente.ativo"
                                    handleOnChange={handleChange}
                                    value={novoAgente.ativo}
                                    checked={!!novoAgente.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparRegistro('agente');
                                    }}
                                    //style={{ marginLeft: "10px" }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novoAgente.funcao.toLowerCase() === 'cancelar' ? 'error' : 'info'}
                                    onClick={() => {
                                        handleNewRegistro(novoAgente, 'agente');
                                    }}
                                    disabled={novoAgente.funcao.toLowerCase() !== 'cancelar' && !novoAgente.descricao}
                                    //style={{ marginLeft: "5px" }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novoAgente.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        {...agenteGrid.props}
                                        columns={columnsagente}
                                        data={itemAgente}
                                        renderRowActions={isMobile ? undefined : ({ row }) => (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <Tooltip title="Editar">
                                                    <span><IconButton type="button" disabled={!podeEditar()}
                                                        onClick={() => handleItemRegistro(row.original, row.index, 'Editar', 'agente')}>
                                                        <Edit />
                                                    </IconButton></span>
                                                </Tooltip>
                                                <Tooltip title="Cancelar">
                                                    <span><IconButton type="button" color="error" disabled={!podeEditar()}
                                                        onClick={() => handleItemRegistro(row.original, row.index, 'Cancelar', 'agente')}>
                                                        <Delete />
                                                    </IconButton></span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        renderRowActionMenuItems={isMobile ? ({ row, closeMenu }) => [
                                            <MenuItem key="editar" disabled={!podeEditar()} onClick={() => {
                                                closeMenu();
                                                handleItemRegistro(row.original, row.index, 'Editar', 'agente');
                                            }}>
                                                <ListItemIcon><Edit fontSize="small" /></ListItemIcon>Editar
                                            </MenuItem>,
                                            <MenuItem key="cancelar" disabled={!podeEditar()} onClick={() => {
                                                closeMenu();
                                                handleItemRegistro(row.original, row.index, 'Cancelar', 'agente');
                                            }}>
                                                <ListItemIcon><Delete color="error" fontSize="small" /></ListItemIcon>Cancelar
                                            </MenuItem>,
                                        ] : undefined}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={formStyles.stiloPadrao}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    //marginTop: "1rem",
                                    flexWrap: 'wrap', // Permite que os itens quebrem a linha quando necessário
                                    // justifyContent: "space-between", // Distribui os itens igualmente
                                }}
                            >
                                <DataList
                                    text="Exame"
                                    name="Exame.descricao"
                                    placeholder={`Pesquise a lista de exames e diagnósticos disponíveis na tabela 27 do eSocial`}
                                    inputWidth="400px"
                                    filteredOptions={optionsExame}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={exame?.descricao || ''}
                                />
                                <Checkbox
                                    title="Exame obrigatório na admissão do colaborador"
                                    text="Admissional"
                                    name="novoProcedimento.admissional"
                                    handleOnChange={handleChange}
                                    value={novoProcedimento.admissional}
                                    checked={!!novoProcedimento.admissional}
                                />
                                <Checkbox
                                    title="Exame obrigatório na demissão do colaborador"
                                    text="Demissional"
                                    name="novoProcedimento.demissional"
                                    handleOnChange={handleChange}
                                    value={novoProcedimento.demissional}
                                    checked={!!novoProcedimento.demissional}
                                />
                                <Checkbox
                                    title="Exame períodico"
                                    text="Períodico"
                                    name="novoProcedimento.periodico"
                                    handleOnChange={handleChange}
                                    value={novoProcedimento.periodico}
                                    checked={!!novoProcedimento.periodico}
                                />
                                <Input
                                    text="Periodicidade"
                                    type="number"
                                    name="novoProcedimento.periodicidade"
                                    title="digite a periodicidade em meses do exame"
                                    inputWidth="100px"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoProcedimento.periodicidade || ''}
                                />
                                <Checkbox
                                    title="Exame obrigatório na mudança da classificação de risco"
                                    text="Mudança Risco"
                                    name="novoProcedimento.mudancaRisco"
                                    handleOnChange={handleChange}
                                    value={novoProcedimento.mudancaRisco}
                                    checked={!!novoProcedimento.mudancaRisco}
                                />
                                <Checkbox
                                    title="Exame obrigatório no retorno ao trabalho"
                                    text="Retorno Trabalho"
                                    name="novoProcedimento.retornoTrabalho"
                                    handleOnChange={handleChange}
                                    value={novoProcedimento.retornoTrabalho}
                                    checked={!!novoProcedimento.retornoTrabalho}
                                />
                                <Checkbox
                                    title="Ativa quando marcado"
                                    text="Ativo"
                                    name="novoProcedimento.ativo"
                                    handleOnChange={handleChange}
                                    value={novoProcedimento.ativo}
                                    checked={!!novoProcedimento.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparRegistro('procedimento');
                                    }}
                                    //style={{ marginLeft: "10px" }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novoProcedimento.funcao.toLowerCase() === 'cancelar' ? 'error' : 'info'}
                                    onClick={() => {
                                        handleNewRegistro(novoProcedimento, 'procedimento');
                                    }}
                                    disabled={
                                        novoProcedimento.funcao.toLowerCase() !== 'cancelar' && !novoProcedimento.tb27eSocialId
                                    }
                                    //style={{ marginLeft: "5px" }}
                                    style={{
                                        marginLeft: '10px',
                                        minWidth: '80px',
                                        fontSize: '14px',
                                        '@media (max-width: 600px)': {
                                            fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                            padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                        },
                                    }}
                                >
                                    {novoProcedimento.funcao}
                                </Button>
                            </div>
                            <div>
                                <ThemeProvider theme={theme}>
                                    <MaterialReactTable
                                        {...procedimentoGrid.props}
                                        columns={columnsprocedimento}
                                        data={itensProcedimento}
                                        renderRowActions={isMobile ? undefined : ({ row }) => (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <Tooltip title="Editar">
                                                    <span><IconButton type="button" disabled={!podeEditar()}
                                                        onClick={() => handleItemRegistro(row.original, row.index, 'Editar', 'procedimento')}>
                                                        <Edit />
                                                    </IconButton></span>
                                                </Tooltip>
                                                <Tooltip title="Cancelar">
                                                    <span><IconButton type="button" color="error" disabled={!podeEditar()}
                                                        onClick={() => handleItemRegistro(row.original, row.index, 'Cancelar', 'procedimento')}>
                                                        <Delete />
                                                    </IconButton></span>
                                                </Tooltip>
                                            </Box>
                                        )}
                                        renderRowActionMenuItems={isMobile ? ({ row, closeMenu }) => [
                                            <MenuItem key="editar" disabled={!podeEditar()} onClick={() => {
                                                closeMenu();
                                                handleItemRegistro(row.original, row.index, 'Editar', 'procedimento');
                                            }}>
                                                <ListItemIcon><Edit fontSize="small" /></ListItemIcon>Editar
                                            </MenuItem>,
                                            <MenuItem key="cancelar" disabled={!podeEditar()} onClick={() => {
                                                closeMenu();
                                                handleItemRegistro(row.original, row.index, 'Cancelar', 'procedimento');
                                            }}>
                                                <ListItemIcon><Delete color="error" fontSize="small" /></ListItemIcon>Cancelar
                                            </MenuItem>,
                                        ] : undefined}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <Box sx={{ mt: 2 }}>
                            <h2>Papéis de Assinatura</h2>
                            <p>Marque os papéis que este cargo pode assinar.</p>

                            <div className={formStyles.form_group_checkbox}>
                                {optionsPapeisAssinatura.map((papel) => (
                                    <Checkbox
                                        key={papel.id}
                                        name={`papel_${papel.id}`}
                                        text={papel.descricao}
                                        checked={papeisAssinaturaSelecionados.includes(papel.id)}
                                        handleOnChange={() => handleTogglePapelAssinatura(papel.id)}
                                    />
                                ))}
                            </div>
                        </Box>
                    </TabPanel>
                    <TabPanel>
                        <Box sx={{ mt: 2 }}>
                            <h2>Cargos Elegíveis</h2>

                            <Checkbox
                                title="Cargo Remunerado"
                                text="Remunerado"
                                name="remunerado"
                                handleOnChange={handleChange}
                                value={dados.remunerado}
                                checked={!!dados.remunerado}
                            />

                            <Checkbox
                                title="Ao marcar esse cargo ficará vinculado a DIRETORIA"
                                text="Diretoria"
                                name="diretoria"
                                handleOnChange={handleChange}
                                value={dados.diretoria}
                                checked={!!dados.diretoria}
                            />
                            <Checkbox
                                title="Ao marcar esse cargo ficará vinculado ao CONSELHO FISCAL"
                                text="Fiscal"
                                name="fiscal"
                                handleOnChange={handleChange}
                                value={dados.fiscal}
                                checked={!!dados.fiscal}
                            />
                            <Checkbox
                                title="Ao marcar esse cargo ficará vinculado a comissões exemplo: Eleitoral"
                                text="Comissão"
                                name="comissao"
                                handleOnChange={handleChange}
                                value={dados.comissao}
                                checked={!!dados.comissao}
                            />
                        </Box>
                    </TabPanel>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                                Voltar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                disabled={novoAgente.descricao || novoProcedimento.tb27eSocialId}
                            >
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
